<p-panel>
    <app-reactive-form-builder 
      (formChanges)="formChanges($event[0], $event[1])" 
      (goBack)="goBack()"
      [form]="form.formFields" 
      [serverUrl]="form.env.auxServerUrl" 
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id ?? ''"
      [request]="this.getType() === 1 ? this.tareasApi.fertilizantes.PUT : this.tareasApi.fertilizantes.POST"
      [getRequest]="getRequest">
    </app-reactive-form-builder>
</p-panel>